import { useState, useEffect } from "react";
import "./style.css";
import {
  Button,
  makeStyles,
  Toaster,
  typographyStyles,
} from "@fluentui/react-components";
import { AddRegular, Delete24Regular } from "@fluentui/react-icons";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import CreateAccountPopup from "./createAccountPopup";
import DeleteAccountPopup from "./deleteAccountPopup";
import ClientPortalData from "./ClientPortalData";
import { useToastMessage } from "../../../components/ToastMessage/ToastMessage";
import { fetchClientAndPartner } from "../../../redux/clientPortal/clientPartnerSlice";
import { convertStringToArray } from "../../../utils";

const useStyles = makeStyles({
  no_data: { ...typographyStyles.subtitle2, color: "red" },
});

function ClientPortal(props: any) {
  const dispatch: AppDispatch = useDispatch();
  const { showToast, toasterId } = useToastMessage();
  const [openPopup, setOpenPopup] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState<{
    id: string;
    type: "client" | "partner";
  } | null>(null);
  const [portalTarget, setPortalTarget] = useState<{
    id: string;
    emailid: string | null;
    type: "client" | "partner";
  } | null>(null);

  const styles = useStyles();

  const { client, partner, loading, error }: any = useSelector(
    (state: RootState) => state.clientPartner
  );
  const activeClientAccount = client.basicInfo?.ActiveOnPortal;
  const activePartnerAccount = useSelector(
    (state: RootState) => state.clientPartner.partner.basicInfo?.ActiveOnPortal
  );
  const partnerId = partner.basicInfo?.CustomerId || null;
  const clientEmail = client.contactInfo?.Email || null;
  const partnerEmail = partner.contactInfo?.Email || null;
  useEffect(() => {
    dispatch(fetchClientAndPartner(props.activeCustomerId));
  }, [props.activeCustomerId]);

  const openCreatePortalPopup = (type: "client" | "partner") => {
    const id = type === "client" ? props.activeCustomerId : partnerId;
    const emailid = type === "client" ? clientEmail : partnerEmail;

    setPortalTarget({ id, emailid, type });
    setOpenPopup(true);
  };

  const handleOpenDeletePopup = (type: "client" | "partner") => {
    const id = type === "client" ? props.activeCustomerId : partnerId;
    setDeleteTarget({ id, type });
    setOpenDeletePopup(true);
  };

  return (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <div className="client_portal_page">
        <div className="cp_group_buttons">
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON
          ).includes("create_portal_client") &&
            !activeClientAccount && (
              <Button
                appearance="primary"
                className="asc-button-primary"
                icon={<AddRegular />}
                onClick={() => openCreatePortalPopup("client")}
              >
                Create Portal Account for Client
              </Button>
            )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON
          ).includes("create_portal_partner") &&
            activeClientAccount &&
            partnerId &&
            !activePartnerAccount && (
              <Button
                appearance="primary"
                className="asc-button-primary"
                icon={<AddRegular />}
                onClick={() => openCreatePortalPopup("partner")}
              >
                Create Portal Account for Partner
              </Button>
            )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON
          ).includes("deactivate_portal_client") &&
            activeClientAccount && (
              <Button
                appearance="outline"
                icon={<Delete24Regular />}
                style={{ color: "red" }}
                onClick={() => handleOpenDeletePopup("client")}
              >
                Deactivate Portal Account for Client
              </Button>
            )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON
          ).includes("deactivate_portal_partner") &&
            activePartnerAccount && (
              <Button
                appearance="outline"
                icon={<Delete24Regular />}
                style={{ color: "red" }}
                onClick={() => handleOpenDeletePopup("partner")}
              >
                Deactivate Portal Account for Partner
              </Button>
            )}
        </div>
        <div className="cp_body">
          {!activeClientAccount && (
            <div className={`${styles.no_data} cp_body_no_data`}>
              There is no Active Account - Click Create Portal Account for
              Client to create a new account
            </div>
          )}
        </div>
        {activeClientAccount && (
          <ClientPortalData
            customerId={props.activeCustomerId}
            notify={showToast}
          />
        )}
        <CreateAccountPopup
          open={openPopup}
          onClose={() => {
            setOpenPopup(false);
            setPortalTarget(null);
          }}
          portalTarget={portalTarget}
          notify={showToast}
          customerId={props.activeCustomerId}
        />
        <DeleteAccountPopup
          idToUse={deleteTarget?.id || ""}
          targetType={deleteTarget?.type || null}
          open={openDeletePopup}
          onClose={() => {
            setOpenDeletePopup(false);
            setDeleteTarget(null);
          }}
          notify={showToast}
          customerId={props.activeCustomerId}
        />
      </div>
    </>
  );
}

export default ClientPortal;
